// AUTO-GENERATED by packages/shared/scripts/generate-icon-names.mjs -- do not edit by hand.
// Source: lucide-react canonical PascalCase exports.
// Regenerate after upgrading lucide-react: `npm run generate:icons -w @adlywise/shared`.
export const ICON_NAMES = [
    "AArrowDown",
    "AArrowUp",
    "ALargeSmall",
    "Accessibility",
    "Activity",
    "AirVent",
    "Airplay",
    "AlarmClock",
    "AlarmClockCheck",
    "AlarmClockMinus",
    "AlarmClockOff",
    "AlarmClockPlus",
    "AlarmSmoke",
    "Album",
    "AlignCenterHorizontal",
    "AlignCenterVertical",
    "AlignEndHorizontal",
    "AlignEndVertical",
    "AlignHorizontalDistributeCenter",
    "AlignHorizontalDistributeEnd",
    "AlignHorizontalDistributeStart",
    "AlignHorizontalJustifyCenter",
    "AlignHorizontalJustifyEnd",
    "AlignHorizontalJustifyStart",
    "AlignHorizontalSpaceAround",
    "AlignHorizontalSpaceBetween",
    "AlignStartHorizontal",
    "AlignStartVertical",
    "AlignVerticalDistributeCenter",
    "AlignVerticalDistributeEnd",
    "AlignVerticalDistributeStart",
    "AlignVerticalJustifyCenter",
    "AlignVerticalJustifyEnd",
    "AlignVerticalJustifyStart",
    "AlignVerticalSpaceAround",
    "AlignVerticalSpaceBetween",
    "Ambulance",
    "Ampersand",
    "Ampersands",
    "Amphora",
    "Anchor",
    "Angry",
    "Annoyed",
    "Antenna",
    "Anvil",
    "Aperture",
    "AppWindow",
    "AppWindowMac",
    "Apple",
    "Archive",
    "ArchiveRestore",
    "ArchiveX",
    "Armchair",
    "ArrowBigDown",
    "ArrowBigDownDash",
    "ArrowBigLeft",
    "ArrowBigLeftDash",
    "ArrowBigRight",
    "ArrowBigRightDash",
    "ArrowBigUp",
    "ArrowBigUpDash",
    "ArrowDown",
    "ArrowDown01",
    "ArrowDown10",
    "ArrowDownAZ",
    "ArrowDownFromLine",
    "ArrowDownLeft",
    "ArrowDownNarrowWide",
    "ArrowDownRight",
    "ArrowDownToDot",
    "ArrowDownToLine",
    "ArrowDownUp",
    "ArrowDownWideNarrow",
    "ArrowDownZA",
    "ArrowLeft",
    "ArrowLeftFromLine",
    "ArrowLeftRight",
    "ArrowLeftToLine",
    "ArrowRight",
    "ArrowRightFromLine",
    "ArrowRightLeft",
    "ArrowRightToLine",
    "ArrowUp",
    "ArrowUp01",
    "ArrowUp10",
    "ArrowUpAZ",
    "ArrowUpDown",
    "ArrowUpFromDot",
    "ArrowUpFromLine",
    "ArrowUpLeft",
    "ArrowUpNarrowWide",
    "ArrowUpRight",
    "ArrowUpToLine",
    "ArrowUpWideNarrow",
    "ArrowUpZA",
    "ArrowsUpFromLine",
    "Asterisk",
    "Astroid",
    "AtSign",
    "Atom",
    "AudioLines",
    "AudioWaveform",
    "Award",
    "Axe",
    "Axis3d",
    "Baby",
    "Backpack",
    "Badge",
    "BadgeAlert",
    "BadgeCent",
    "BadgeCheck",
    "BadgeDollarSign",
    "BadgeEuro",
    "BadgeIndianRupee",
    "BadgeInfo",
    "BadgeJapaneseYen",
    "BadgeMinus",
    "BadgePercent",
    "BadgePlus",
    "BadgePoundSterling",
    "BadgeQuestionMark",
    "BadgeRussianRuble",
    "BadgeSwissFranc",
    "BadgeTurkishLira",
    "BadgeX",
    "BaggageClaim",
    "Balloon",
    "Ban",
    "Banana",
    "Bandage",
    "Banknote",
    "BanknoteArrowDown",
    "BanknoteArrowUp",
    "BanknoteX",
    "Barcode",
    "Barrel",
    "Baseline",
    "Bath",
    "Battery",
    "BatteryCharging",
    "BatteryFull",
    "BatteryLow",
    "BatteryMedium",
    "BatteryPlus",
    "BatteryWarning",
    "Beaker",
    "Bean",
    "BeanOff",
    "Bed",
    "BedDouble",
    "BedSingle",
    "Beef",
    "BeefOff",
    "Beer",
    "BeerOff",
    "Bell",
    "BellCheck",
    "BellDot",
    "BellElectric",
    "BellMinus",
    "BellOff",
    "BellPlus",
    "BellRing",
    "BetweenHorizontalEnd",
    "BetweenHorizontalStart",
    "BetweenVerticalEnd",
    "BetweenVerticalStart",
    "BicepsFlexed",
    "Bike",
    "Binary",
    "Binoculars",
    "Biohazard",
    "Bird",
    "Birdhouse",
    "Bitcoin",
    "Blend",
    "Blender",
    "Blinds",
    "Blocks",
    "Bluetooth",
    "BluetoothConnected",
    "BluetoothOff",
    "BluetoothSearching",
    "Bold",
    "Bolt",
    "Bomb",
    "Bone",
    "Book",
    "BookA",
    "BookAlert",
    "BookAudio",
    "BookCheck",
    "BookCopy",
    "BookDashed",
    "BookDown",
    "BookHeadphones",
    "BookHeart",
    "BookImage",
    "BookKey",
    "BookLock",
    "BookMarked",
    "BookMinus",
    "BookOpen",
    "BookOpenCheck",
    "BookOpenText",
    "BookPlus",
    "BookSearch",
    "BookText",
    "BookType",
    "BookUp",
    "BookUp2",
    "BookUser",
    "BookX",
    "Bookmark",
    "BookmarkCheck",
    "BookmarkMinus",
    "BookmarkOff",
    "BookmarkPlus",
    "BookmarkX",
    "BoomBox",
    "Bot",
    "BotMessageSquare",
    "BotOff",
    "BottleWine",
    "BowArrow",
    "Box",
    "Boxes",
    "Braces",
    "Brackets",
    "Brain",
    "BrainCircuit",
    "BrainCog",
    "BrickWall",
    "BrickWallFire",
    "BrickWallShield",
    "Briefcase",
    "BriefcaseBusiness",
    "BriefcaseConveyorBelt",
    "BriefcaseMedical",
    "BringToFront",
    "Broccoli",
    "Brush",
    "BrushCleaning",
    "Bubbles",
    "Bug",
    "BugOff",
    "BugPlay",
    "Building",
    "Building2",
    "Bus",
    "BusFront",
    "Cable",
    "CableCar",
    "Cake",
    "CakeSlice",
    "Calculator",
    "Calendar",
    "Calendar1",
    "CalendarArrowDown",
    "CalendarArrowUp",
    "CalendarCheck",
    "CalendarCheck2",
    "CalendarClock",
    "CalendarCog",
    "CalendarDays",
    "CalendarFold",
    "CalendarHeart",
    "CalendarMinus",
    "CalendarMinus2",
    "CalendarOff",
    "CalendarPlus",
    "CalendarPlus2",
    "CalendarRange",
    "CalendarSearch",
    "CalendarSync",
    "CalendarX",
    "CalendarX2",
    "Calendars",
    "Camera",
    "CameraOff",
    "Candy",
    "CandyCane",
    "CandyOff",
    "Cannabis",
    "CannabisOff",
    "Captions",
    "CaptionsOff",
    "Car",
    "CarFront",
    "CarTaxiFront",
    "Caravan",
    "CardSim",
    "Carrot",
    "CaseLower",
    "CaseSensitive",
    "CaseUpper",
    "CassetteTape",
    "Cast",
    "Castle",
    "Cat",
    "Cctv",
    "CctvOff",
    "ChartArea",
    "ChartBar",
    "ChartBarBig",
    "ChartBarDecreasing",
    "ChartBarIncreasing",
    "ChartBarStacked",
    "ChartCandlestick",
    "ChartColumn",
    "ChartColumnBig",
    "ChartColumnDecreasing",
    "ChartColumnIncreasing",
    "ChartColumnStacked",
    "ChartGantt",
    "ChartLine",
    "ChartNetwork",
    "ChartNoAxesColumn",
    "ChartNoAxesColumnDecreasing",
    "ChartNoAxesColumnIncreasing",
    "ChartNoAxesCombined",
    "ChartNoAxesGantt",
    "ChartPie",
    "ChartScatter",
    "ChartSpline",
    "Check",
    "CheckCheck",
    "CheckLine",
    "ChefHat",
    "Cherry",
    "ChessBishop",
    "ChessKing",
    "ChessKnight",
    "ChessPawn",
    "ChessQueen",
    "ChessRook",
    "ChevronDown",
    "ChevronFirst",
    "ChevronLast",
    "ChevronLeft",
    "ChevronRight",
    "ChevronUp",
    "ChevronsDown",
    "ChevronsDownUp",
    "ChevronsLeft",
    "ChevronsLeftRight",
    "ChevronsLeftRightEllipsis",
    "ChevronsRight",
    "ChevronsRightLeft",
    "ChevronsUp",
    "ChevronsUpDown",
    "Church",
    "Cigarette",
    "CigaretteOff",
    "Circle",
    "CircleAlert",
    "CircleArrowDown",
    "CircleArrowLeft",
    "CircleArrowOutDownLeft",
    "CircleArrowOutDownRight",
    "CircleArrowOutUpLeft",
    "CircleArrowOutUpRight",
    "CircleArrowRight",
    "CircleArrowUp",
    "CircleCheck",
    "CircleCheckBig",
    "CircleChevronDown",
    "CircleChevronLeft",
    "CircleChevronRight",
    "CircleChevronUp",
    "CircleDashed",
    "CircleDivide",
    "CircleDollarSign",
    "CircleDot",
    "CircleDotDashed",
    "CircleEllipsis",
    "CircleEqual",
    "CircleFadingArrowUp",
    "CircleFadingPlus",
    "CircleGauge",
    "CircleMinus",
    "CircleOff",
    "CircleParking",
    "CircleParkingOff",
    "CirclePause",
    "CirclePercent",
    "CirclePile",
    "CirclePlay",
    "CirclePlus",
    "CirclePoundSterling",
    "CirclePower",
    "CircleQuestionMark",
    "CircleSlash",
    "CircleSlash2",
    "CircleSmall",
    "CircleStar",
    "CircleStop",
    "CircleUser",
    "CircleUserRound",
    "CircleX",
    "CircuitBoard",
    "Citrus",
    "Clapperboard",
    "Clipboard",
    "ClipboardCheck",
    "ClipboardClock",
    "ClipboardCopy",
    "ClipboardList",
    "ClipboardMinus",
    "ClipboardPaste",
    "ClipboardPen",
    "ClipboardPenLine",
    "ClipboardPlus",
    "ClipboardType",
    "ClipboardX",
    "Clock",
    "Clock1",
    "Clock10",
    "Clock11",
    "Clock12",
    "Clock2",
    "Clock3",
    "Clock4",
    "Clock5",
    "Clock6",
    "Clock7",
    "Clock8",
    "Clock9",
    "ClockAlert",
    "ClockArrowDown",
    "ClockArrowUp",
    "ClockCheck",
    "ClockFading",
    "ClockPlus",
    "ClosedCaption",
    "Cloud",
    "CloudAlert",
    "CloudBackup",
    "CloudCheck",
    "CloudCog",
    "CloudDownload",
    "CloudDrizzle",
    "CloudFog",
    "CloudHail",
    "CloudLightning",
    "CloudMoon",
    "CloudMoonRain",
    "CloudOff",
    "CloudRain",
    "CloudRainWind",
    "CloudSnow",
    "CloudSun",
    "CloudSunRain",
    "CloudSync",
    "CloudUpload",
    "Cloudy",
    "Clover",
    "Club",
    "Code",
    "CodeXml",
    "Coffee",
    "Cog",
    "Coins",
    "Columns2",
    "Columns3",
    "Columns3Cog",
    "Columns4",
    "Combine",
    "Command",
    "Compass",
    "Component",
    "Computer",
    "ConciergeBell",
    "Cone",
    "Construction",
    "Contact",
    "ContactRound",
    "Container",
    "Contrast",
    "Cookie",
    "CookingPot",
    "Copy",
    "CopyCheck",
    "CopyMinus",
    "CopyPlus",
    "CopySlash",
    "CopyX",
    "Copyleft",
    "Copyright",
    "CornerDownLeft",
    "CornerDownRight",
    "CornerLeftDown",
    "CornerLeftUp",
    "CornerRightDown",
    "CornerRightUp",
    "CornerUpLeft",
    "CornerUpRight",
    "Cpu",
    "CreativeCommons",
    "CreditCard",
    "Croissant",
    "Crop",
    "Cross",
    "Crosshair",
    "Crown",
    "Cuboid",
    "CupSoda",
    "Currency",
    "Cylinder",
    "Dam",
    "Database",
    "DatabaseBackup",
    "DatabaseSearch",
    "DatabaseZap",
    "DecimalsArrowLeft",
    "DecimalsArrowRight",
    "Delete",
    "Dessert",
    "Diameter",
    "Diamond",
    "DiamondMinus",
    "DiamondPercent",
    "DiamondPlus",
    "Dice1",
    "Dice2",
    "Dice3",
    "Dice4",
    "Dice5",
    "Dice6",
    "Dices",
    "Diff",
    "Disc",
    "Disc2",
    "Disc3",
    "DiscAlbum",
    "Divide",
    "Dna",
    "DnaOff",
    "Dock",
    "Dog",
    "DollarSign",
    "Donut",
    "DoorClosed",
    "DoorClosedLocked",
    "DoorOpen",
    "Dot",
    "Download",
    "DraftingCompass",
    "Drama",
    "Drill",
    "Drone",
    "Droplet",
    "DropletOff",
    "Droplets",
    "Drum",
    "Drumstick",
    "Dumbbell",
    "Ear",
    "EarOff",
    "Earth",
    "EarthLock",
    "Eclipse",
    "Egg",
    "EggFried",
    "EggOff",
    "Ellipse",
    "Ellipsis",
    "EllipsisVertical",
    "Equal",
    "EqualApproximately",
    "EqualNot",
    "Eraser",
    "EthernetPort",
    "Euro",
    "EvCharger",
    "Expand",
    "ExternalLink",
    "Eye",
    "EyeClosed",
    "EyeOff",
    "Factory",
    "Fan",
    "FastForward",
    "Feather",
    "Fence",
    "FerrisWheel",
    "File",
    "FileArchive",
    "FileAxis3d",
    "FileBadge",
    "FileBox",
    "FileBraces",
    "FileBracesCorner",
    "FileChartColumn",
    "FileChartColumnIncreasing",
    "FileChartLine",
    "FileChartPie",
    "FileCheck",
    "FileCheckCorner",
    "FileClock",
    "FileCode",
    "FileCodeCorner",
    "FileCog",
    "FileDiff",
    "FileDigit",
    "FileDown",
    "FileExclamationPoint",
    "FileHeadphone",
    "FileHeart",
    "FileImage",
    "FileInput",
    "FileKey",
    "FileLock",
    "FileMinus",
    "FileMinusCorner",
    "FileMusic",
    "FileOutput",
    "FilePen",
    "FilePenLine",
    "FilePlay",
    "FilePlus",
    "FilePlusCorner",
    "FileQuestionMark",
    "FileScan",
    "FileSearch",
    "FileSearchCorner",
    "FileSignal",
    "FileSliders",
    "FileSpreadsheet",
    "FileStack",
    "FileSymlink",
    "FileTerminal",
    "FileText",
    "FileType",
    "FileTypeCorner",
    "FileUp",
    "FileUser",
    "FileVideoCamera",
    "FileVolume",
    "FileX",
    "FileXCorner",
    "Files",
    "Film",
    "FingerprintPattern",
    "FireExtinguisher",
    "Fish",
    "FishOff",
    "FishSymbol",
    "FishingHook",
    "FishingRod",
    "Flag",
    "FlagOff",
    "FlagTriangleLeft",
    "FlagTriangleRight",
    "Flame",
    "FlameKindling",
    "Flashlight",
    "FlashlightOff",
    "FlaskConical",
    "FlaskConicalOff",
    "FlaskRound",
    "FlipHorizontal2",
    "FlipVertical2",
    "Flower",
    "Flower2",
    "Focus",
    "FoldHorizontal",
    "FoldVertical",
    "Folder",
    "FolderArchive",
    "FolderBookmark",
    "FolderCheck",
    "FolderClock",
    "FolderClosed",
    "FolderCode",
    "FolderCog",
    "FolderDot",
    "FolderDown",
    "FolderGit",
    "FolderGit2",
    "FolderHeart",
    "FolderInput",
    "FolderKanban",
    "FolderKey",
    "FolderLock",
    "FolderMinus",
    "FolderOpen",
    "FolderOpenDot",
    "FolderOutput",
    "FolderPen",
    "FolderPlus",
    "FolderRoot",
    "FolderSearch",
    "FolderSearch2",
    "FolderSymlink",
    "FolderSync",
    "FolderTree",
    "FolderUp",
    "FolderX",
    "Folders",
    "Footprints",
    "Forklift",
    "Form",
    "Forward",
    "Frame",
    "Frown",
    "Fuel",
    "Fullscreen",
    "Funnel",
    "FunnelPlus",
    "FunnelX",
    "GalleryHorizontal",
    "GalleryHorizontalEnd",
    "GalleryThumbnails",
    "GalleryVertical",
    "GalleryVerticalEnd",
    "Gamepad",
    "Gamepad2",
    "GamepadDirectional",
    "Gauge",
    "Gavel",
    "Gem",
    "GeorgianLari",
    "Ghost",
    "Gift",
    "GitBranch",
    "GitBranchMinus",
    "GitBranchPlus",
    "GitCommitHorizontal",
    "GitCommitVertical",
    "GitCompare",
    "GitCompareArrows",
    "GitFork",
    "GitGraph",
    "GitMerge",
    "GitMergeConflict",
    "GitPullRequest",
    "GitPullRequestArrow",
    "GitPullRequestClosed",
    "GitPullRequestCreate",
    "GitPullRequestCreateArrow",
    "GitPullRequestDraft",
    "GlassWater",
    "Glasses",
    "Globe",
    "GlobeCheck",
    "GlobeLock",
    "GlobeOff",
    "GlobeX",
    "Goal",
    "Gpu",
    "GraduationCap",
    "Grape",
    "Grid2x2",
    "Grid2x2Check",
    "Grid2x2Plus",
    "Grid2x2X",
    "Grid3x2",
    "Grid3x3",
    "Grip",
    "GripHorizontal",
    "GripVertical",
    "Group",
    "Guitar",
    "Ham",
    "Hamburger",
    "Hammer",
    "Hand",
    "HandCoins",
    "HandFist",
    "HandGrab",
    "HandHeart",
    "HandHelping",
    "HandMetal",
    "HandPlatter",
    "Handbag",
    "Handshake",
    "HardDrive",
    "HardDriveDownload",
    "HardDriveUpload",
    "HardHat",
    "Hash",
    "HatGlasses",
    "Haze",
    "Hd",
    "HdmiPort",
    "Heading",
    "Heading1",
    "Heading2",
    "Heading3",
    "Heading4",
    "Heading5",
    "Heading6",
    "HeadphoneOff",
    "Headphones",
    "Headset",
    "Heart",
    "HeartCrack",
    "HeartHandshake",
    "HeartMinus",
    "HeartOff",
    "HeartPlus",
    "HeartPulse",
    "HeartX",
    "Heater",
    "Helicopter",
    "Hexagon",
    "Highlighter",
    "History",
    "Hop",
    "HopOff",
    "Hospital",
    "Hotel",
    "Hourglass",
    "House",
    "HouseHeart",
    "HousePlug",
    "HousePlus",
    "HouseWifi",
    "IceCreamBowl",
    "IceCreamCone",
    "IdCard",
    "IdCardLanyard",
    "Image",
    "ImageDown",
    "ImageMinus",
    "ImageOff",
    "ImagePlay",
    "ImagePlus",
    "ImageUp",
    "ImageUpscale",
    "Images",
    "Import",
    "Inbox",
    "IndianRupee",
    "Infinity",
    "Info",
    "InspectionPanel",
    "Italic",
    "IterationCcw",
    "IterationCw",
    "JapaneseYen",
    "Joystick",
    "Kanban",
    "Kayak",
    "Key",
    "KeyRound",
    "KeySquare",
    "Keyboard",
    "KeyboardMusic",
    "KeyboardOff",
    "Lamp",
    "LampCeiling",
    "LampDesk",
    "LampFloor",
    "LampWallDown",
    "LampWallUp",
    "LandPlot",
    "Landmark",
    "Languages",
    "Laptop",
    "LaptopMinimal",
    "LaptopMinimalCheck",
    "Lasso",
    "LassoSelect",
    "Laugh",
    "Layers",
    "Layers2",
    "LayersMinus",
    "LayersPlus",
    "LayoutDashboard",
    "LayoutGrid",
    "LayoutList",
    "LayoutPanelLeft",
    "LayoutPanelTop",
    "LayoutTemplate",
    "Leaf",
    "LeafyGreen",
    "Lectern",
    "LensConcave",
    "LensConvex",
    "Library",
    "LibraryBig",
    "LifeBuoy",
    "Ligature",
    "Lightbulb",
    "LightbulbOff",
    "LineDotRightHorizontal",
    "LineSquiggle",
    "LineStyle",
    "Link",
    "Link2",
    "Link2Off",
    "List",
    "ListCheck",
    "ListChecks",
    "ListChevronsDownUp",
    "ListChevronsUpDown",
    "ListCollapse",
    "ListEnd",
    "ListFilter",
    "ListFilterPlus",
    "ListIndentDecrease",
    "ListIndentIncrease",
    "ListMinus",
    "ListMusic",
    "ListOrdered",
    "ListPlus",
    "ListRestart",
    "ListStart",
    "ListTodo",
    "ListTree",
    "ListVideo",
    "ListX",
    "Loader",
    "LoaderCircle",
    "LoaderPinwheel",
    "Locate",
    "LocateFixed",
    "LocateOff",
    "Lock",
    "LockKeyhole",
    "LockKeyholeOpen",
    "LockOpen",
    "LogIn",
    "LogOut",
    "Logs",
    "Lollipop",
    "LucideProvider",
    "Luggage",
    "Magnet",
    "Mail",
    "MailCheck",
    "MailMinus",
    "MailOpen",
    "MailPlus",
    "MailQuestionMark",
    "MailSearch",
    "MailWarning",
    "MailX",
    "Mailbox",
    "Mails",
    "Map",
    "MapMinus",
    "MapPin",
    "MapPinCheck",
    "MapPinCheckInside",
    "MapPinHouse",
    "MapPinMinus",
    "MapPinMinusInside",
    "MapPinOff",
    "MapPinPen",
    "MapPinPlus",
    "MapPinPlusInside",
    "MapPinSearch",
    "MapPinX",
    "MapPinXInside",
    "MapPinned",
    "MapPlus",
    "Mars",
    "MarsStroke",
    "Martini",
    "Maximize",
    "Maximize2",
    "Medal",
    "Megaphone",
    "MegaphoneOff",
    "Meh",
    "MemoryStick",
    "Menu",
    "Merge",
    "MessageCircle",
    "MessageCircleCheck",
    "MessageCircleCode",
    "MessageCircleDashed",
    "MessageCircleHeart",
    "MessageCircleMore",
    "MessageCircleOff",
    "MessageCirclePlus",
    "MessageCircleQuestionMark",
    "MessageCircleReply",
    "MessageCircleWarning",
    "MessageCircleX",
    "MessageSquare",
    "MessageSquareCheck",
    "MessageSquareCode",
    "MessageSquareDashed",
    "MessageSquareDiff",
    "MessageSquareDot",
    "MessageSquareHeart",
    "MessageSquareLock",
    "MessageSquareMore",
    "MessageSquareOff",
    "MessageSquarePlus",
    "MessageSquareQuote",
    "MessageSquareReply",
    "MessageSquareShare",
    "MessageSquareText",
    "MessageSquareWarning",
    "MessageSquareX",
    "MessagesSquare",
    "Metronome",
    "Mic",
    "MicOff",
    "MicVocal",
    "Microchip",
    "Microscope",
    "Microwave",
    "Milestone",
    "Milk",
    "MilkOff",
    "Minimize",
    "Minimize2",
    "Minus",
    "MirrorRectangular",
    "MirrorRound",
    "Monitor",
    "MonitorCheck",
    "MonitorCloud",
    "MonitorCog",
    "MonitorDot",
    "MonitorDown",
    "MonitorOff",
    "MonitorPause",
    "MonitorPlay",
    "MonitorSmartphone",
    "MonitorSpeaker",
    "MonitorStop",
    "MonitorUp",
    "MonitorX",
    "Moon",
    "MoonStar",
    "Motorbike",
    "Mountain",
    "MountainSnow",
    "Mouse",
    "MouseLeft",
    "MouseOff",
    "MousePointer",
    "MousePointer2",
    "MousePointer2Off",
    "MousePointerBan",
    "MousePointerClick",
    "MouseRight",
    "Move",
    "Move3d",
    "MoveDiagonal",
    "MoveDiagonal2",
    "MoveDown",
    "MoveDownLeft",
    "MoveDownRight",
    "MoveHorizontal",
    "MoveLeft",
    "MoveRight",
    "MoveUp",
    "MoveUpLeft",
    "MoveUpRight",
    "MoveVertical",
    "Music",
    "Music2",
    "Music3",
    "Music4",
    "Navigation",
    "Navigation2",
    "Navigation2Off",
    "NavigationOff",
    "Network",
    "Newspaper",
    "Nfc",
    "NonBinary",
    "Notebook",
    "NotebookPen",
    "NotebookTabs",
    "NotebookText",
    "NotepadText",
    "NotepadTextDashed",
    "Nut",
    "NutOff",
    "Octagon",
    "OctagonAlert",
    "OctagonMinus",
    "OctagonPause",
    "OctagonX",
    "Omega",
    "Option",
    "Orbit",
    "Origami",
    "Package",
    "Package2",
    "PackageCheck",
    "PackageMinus",
    "PackageOpen",
    "PackagePlus",
    "PackageSearch",
    "PackageX",
    "PaintBucket",
    "PaintRoller",
    "Paintbrush",
    "PaintbrushVertical",
    "Palette",
    "Panda",
    "PanelBottom",
    "PanelBottomClose",
    "PanelBottomDashed",
    "PanelBottomOpen",
    "PanelLeft",
    "PanelLeftClose",
    "PanelLeftDashed",
    "PanelLeftOpen",
    "PanelLeftRightDashed",
    "PanelRight",
    "PanelRightClose",
    "PanelRightDashed",
    "PanelRightOpen",
    "PanelTop",
    "PanelTopBottomDashed",
    "PanelTopClose",
    "PanelTopDashed",
    "PanelTopOpen",
    "PanelsLeftBottom",
    "PanelsRightBottom",
    "PanelsTopLeft",
    "Paperclip",
    "Parasol",
    "Parentheses",
    "ParkingMeter",
    "PartyPopper",
    "Pause",
    "PawPrint",
    "PcCase",
    "Pen",
    "PenLine",
    "PenOff",
    "PenTool",
    "Pencil",
    "PencilLine",
    "PencilOff",
    "PencilRuler",
    "Pentagon",
    "Percent",
    "PersonStanding",
    "PhilippinePeso",
    "Phone",
    "PhoneCall",
    "PhoneForwarded",
    "PhoneIncoming",
    "PhoneMissed",
    "PhoneOff",
    "PhoneOutgoing",
    "Pi",
    "Piano",
    "Pickaxe",
    "PictureInPicture",
    "PictureInPicture2",
    "PiggyBank",
    "Pilcrow",
    "PilcrowLeft",
    "PilcrowRight",
    "Pill",
    "PillBottle",
    "Pin",
    "PinOff",
    "Pipette",
    "Pizza",
    "Plane",
    "PlaneLanding",
    "PlaneTakeoff",
    "Play",
    "Plug",
    "Plug2",
    "PlugZap",
    "Plus",
    "PocketKnife",
    "Podcast",
    "Pointer",
    "PointerOff",
    "Popcorn",
    "Popsicle",
    "PoundSterling",
    "Power",
    "PowerOff",
    "Presentation",
    "Printer",
    "PrinterCheck",
    "PrinterX",
    "Projector",
    "Proportions",
    "Puzzle",
    "Pyramid",
    "QrCode",
    "Quote",
    "Rabbit",
    "Radar",
    "Radiation",
    "Radical",
    "Radio",
    "RadioOff",
    "RadioReceiver",
    "RadioTower",
    "Radius",
    "Rainbow",
    "Rat",
    "Ratio",
    "Receipt",
    "ReceiptCent",
    "ReceiptEuro",
    "ReceiptIndianRupee",
    "ReceiptJapaneseYen",
    "ReceiptPoundSterling",
    "ReceiptRussianRuble",
    "ReceiptSwissFranc",
    "ReceiptText",
    "ReceiptTurkishLira",
    "RectangleCircle",
    "RectangleEllipsis",
    "RectangleGoggles",
    "RectangleHorizontal",
    "RectangleVertical",
    "Recycle",
    "Redo",
    "Redo2",
    "RedoDot",
    "RefreshCcw",
    "RefreshCcwDot",
    "RefreshCw",
    "RefreshCwOff",
    "Refrigerator",
    "Regex",
    "RemoveFormatting",
    "Repeat",
    "Repeat1",
    "Repeat2",
    "RepeatOff",
    "Replace",
    "ReplaceAll",
    "Reply",
    "ReplyAll",
    "Rewind",
    "Ribbon",
    "Road",
    "Rocket",
    "RockingChair",
    "RollerCoaster",
    "Rose",
    "Rotate3d",
    "RotateCcw",
    "RotateCcwKey",
    "RotateCcwSquare",
    "RotateCw",
    "RotateCwSquare",
    "Route",
    "RouteOff",
    "Router",
    "Rows2",
    "Rows3",
    "Rows4",
    "Rss",
    "Ruler",
    "RulerDimensionLine",
    "RussianRuble",
    "Sailboat",
    "Salad",
    "Sandwich",
    "Satellite",
    "SatelliteDish",
    "SaudiRiyal",
    "Save",
    "SaveAll",
    "SaveOff",
    "Scale",
    "Scale3d",
    "Scaling",
    "Scan",
    "ScanBarcode",
    "ScanEye",
    "ScanFace",
    "ScanHeart",
    "ScanLine",
    "ScanQrCode",
    "ScanSearch",
    "ScanText",
    "School",
    "Scissors",
    "ScissorsLineDashed",
    "Scooter",
    "ScreenShare",
    "ScreenShareOff",
    "Scroll",
    "ScrollText",
    "Search",
    "SearchAlert",
    "SearchCheck",
    "SearchCode",
    "SearchSlash",
    "SearchX",
    "Section",
    "Send",
    "SendHorizontal",
    "SendToBack",
    "SeparatorHorizontal",
    "SeparatorVertical",
    "Server",
    "ServerCog",
    "ServerCrash",
    "ServerOff",
    "Settings",
    "Settings2",
    "Shapes",
    "Share",
    "Share2",
    "Sheet",
    "Shell",
    "ShelvingUnit",
    "Shield",
    "ShieldAlert",
    "ShieldBan",
    "ShieldCheck",
    "ShieldCog",
    "ShieldCogCorner",
    "ShieldEllipsis",
    "ShieldHalf",
    "ShieldMinus",
    "ShieldOff",
    "ShieldPlus",
    "ShieldQuestionMark",
    "ShieldUser",
    "ShieldX",
    "Ship",
    "ShipWheel",
    "Shirt",
    "ShoppingBag",
    "ShoppingBasket",
    "ShoppingCart",
    "Shovel",
    "ShowerHead",
    "Shredder",
    "Shrimp",
    "Shrink",
    "Shrub",
    "Shuffle",
    "Sigma",
    "Signal",
    "SignalHigh",
    "SignalLow",
    "SignalMedium",
    "SignalZero",
    "Signature",
    "Signpost",
    "SignpostBig",
    "Siren",
    "SkipBack",
    "SkipForward",
    "Skull",
    "Slash",
    "Slice",
    "SlidersHorizontal",
    "SlidersVertical",
    "Smartphone",
    "SmartphoneCharging",
    "SmartphoneNfc",
    "Smile",
    "SmilePlus",
    "Snail",
    "Snowflake",
    "SoapDispenserDroplet",
    "Sofa",
    "SolarPanel",
    "Soup",
    "Space",
    "Spade",
    "Sparkle",
    "Sparkles",
    "Speaker",
    "Speech",
    "SpellCheck",
    "SpellCheck2",
    "Spline",
    "SplinePointer",
    "Split",
    "Spool",
    "SportShoe",
    "Spotlight",
    "SprayCan",
    "Sprout",
    "Square",
    "SquareActivity",
    "SquareArrowDown",
    "SquareArrowDownLeft",
    "SquareArrowDownRight",
    "SquareArrowLeft",
    "SquareArrowOutDownLeft",
    "SquareArrowOutDownRight",
    "SquareArrowOutUpLeft",
    "SquareArrowOutUpRight",
    "SquareArrowRight",
    "SquareArrowRightEnter",
    "SquareArrowRightExit",
    "SquareArrowUp",
    "SquareArrowUpLeft",
    "SquareArrowUpRight",
    "SquareAsterisk",
    "SquareBottomDashedScissors",
    "SquareCenterlineDashedHorizontal",
    "SquareCenterlineDashedVertical",
    "SquareChartGantt",
    "SquareCheck",
    "SquareCheckBig",
    "SquareChevronDown",
    "SquareChevronLeft",
    "SquareChevronRight",
    "SquareChevronUp",
    "SquareCode",
    "SquareDashed",
    "SquareDashedBottom",
    "SquareDashedBottomCode",
    "SquareDashedKanban",
    "SquareDashedMousePointer",
    "SquareDashedText",
    "SquareDashedTopSolid",
    "SquareDivide",
    "SquareDot",
    "SquareEqual",
    "SquareFunction",
    "SquareKanban",
    "SquareLibrary",
    "SquareM",
    "SquareMenu",
    "SquareMinus",
    "SquareMousePointer",
    "SquareParking",
    "SquareParkingOff",
    "SquarePause",
    "SquarePen",
    "SquarePercent",
    "SquarePi",
    "SquarePilcrow",
    "SquarePlay",
    "SquarePlus",
    "SquarePower",
    "SquareRadical",
    "SquareRoundCorner",
    "SquareScissors",
    "SquareSigma",
    "SquareSlash",
    "SquareSplitHorizontal",
    "SquareSplitVertical",
    "SquareSquare",
    "SquareStack",
    "SquareStar",
    "SquareStop",
    "SquareTerminal",
    "SquareUser",
    "SquareUserRound",
    "SquareX",
    "SquaresExclude",
    "SquaresIntersect",
    "SquaresSubtract",
    "SquaresUnite",
    "Squircle",
    "SquircleDashed",
    "Squirrel",
    "Stamp",
    "Star",
    "StarHalf",
    "StarOff",
    "StepBack",
    "StepForward",
    "Stethoscope",
    "Sticker",
    "StickyNote",
    "StickyNoteCheck",
    "StickyNoteMinus",
    "StickyNoteOff",
    "StickyNotePlus",
    "StickyNoteX",
    "StickyNotes",
    "Stone",
    "Store",
    "StretchHorizontal",
    "StretchVertical",
    "Strikethrough",
    "Subscript",
    "Sun",
    "SunDim",
    "SunMedium",
    "SunMoon",
    "SunSnow",
    "Sunrise",
    "Sunset",
    "Superscript",
    "SwatchBook",
    "SwissFranc",
    "SwitchCamera",
    "Sword",
    "Swords",
    "Syringe",
    "Table",
    "Table2",
    "TableCellsMerge",
    "TableCellsSplit",
    "TableColumnsSplit",
    "TableOfContents",
    "TableProperties",
    "TableRowsSplit",
    "Tablet",
    "TabletSmartphone",
    "Tablets",
    "Tag",
    "Tags",
    "Tally1",
    "Tally2",
    "Tally3",
    "Tally4",
    "Tally5",
    "Tangent",
    "Target",
    "Telescope",
    "Tent",
    "TentTree",
    "Terminal",
    "TestTube",
    "TestTubeDiagonal",
    "TestTubes",
    "TextAlignCenter",
    "TextAlignEnd",
    "TextAlignJustify",
    "TextAlignStart",
    "TextCursor",
    "TextCursorInput",
    "TextInitial",
    "TextQuote",
    "TextSearch",
    "TextWrap",
    "Theater",
    "Thermometer",
    "ThermometerSnowflake",
    "ThermometerSun",
    "ThumbsDown",
    "ThumbsUp",
    "Ticket",
    "TicketCheck",
    "TicketMinus",
    "TicketPercent",
    "TicketPlus",
    "TicketSlash",
    "TicketX",
    "Tickets",
    "TicketsPlane",
    "Timeline",
    "Timer",
    "TimerOff",
    "TimerReset",
    "ToggleLeft",
    "ToggleRight",
    "Toilet",
    "ToolCase",
    "Toolbox",
    "Tornado",
    "Torus",
    "Touchpad",
    "TouchpadOff",
    "TowelRack",
    "TowerControl",
    "ToyBrick",
    "Tractor",
    "TrafficCone",
    "TrainFront",
    "TrainFrontTunnel",
    "TrainTrack",
    "TramFront",
    "Transgender",
    "Trash",
    "Trash2",
    "TreeDeciduous",
    "TreePalm",
    "TreePine",
    "Trees",
    "TrendingDown",
    "TrendingUp",
    "TrendingUpDown",
    "Triangle",
    "TriangleAlert",
    "TriangleDashed",
    "TriangleRight",
    "Trophy",
    "Truck",
    "TruckElectric",
    "TurkishLira",
    "Turntable",
    "Turtle",
    "Tv",
    "TvMinimal",
    "TvMinimalPlay",
    "Type",
    "TypeOutline",
    "Umbrella",
    "UmbrellaOff",
    "Underline",
    "Undo",
    "Undo2",
    "UndoDot",
    "UnfoldHorizontal",
    "UnfoldVertical",
    "Ungroup",
    "University",
    "Unlink",
    "Unlink2",
    "Unplug",
    "Upload",
    "Usb",
    "User",
    "UserCheck",
    "UserCog",
    "UserKey",
    "UserLock",
    "UserMinus",
    "UserPen",
    "UserPlus",
    "UserRound",
    "UserRoundCheck",
    "UserRoundCog",
    "UserRoundKey",
    "UserRoundMinus",
    "UserRoundPen",
    "UserRoundPlus",
    "UserRoundSearch",
    "UserRoundX",
    "UserSearch",
    "UserStar",
    "UserX",
    "Users",
    "UsersRound",
    "Utensils",
    "UtensilsCrossed",
    "UtilityPole",
    "Van",
    "Variable",
    "Vault",
    "VectorSquare",
    "Vegan",
    "VenetianMask",
    "Venus",
    "VenusAndMars",
    "Vibrate",
    "VibrateOff",
    "Video",
    "VideoOff",
    "Videotape",
    "View",
    "Voicemail",
    "Volleyball",
    "Volume",
    "Volume1",
    "Volume2",
    "VolumeOff",
    "VolumeX",
    "Vote",
    "Wallet",
    "WalletCards",
    "WalletMinimal",
    "Wallpaper",
    "Wand",
    "WandSparkles",
    "Warehouse",
    "WashingMachine",
    "Watch",
    "WavesArrowDown",
    "WavesArrowUp",
    "WavesHorizontal",
    "WavesLadder",
    "WavesVertical",
    "Waypoints",
    "Webcam",
    "Webhook",
    "WebhookOff",
    "Weight",
    "WeightTilde",
    "Wheat",
    "WheatOff",
    "WholeWord",
    "Wifi",
    "WifiCog",
    "WifiHigh",
    "WifiLow",
    "WifiOff",
    "WifiPen",
    "WifiSync",
    "WifiZero",
    "Wind",
    "WindArrowDown",
    "Wine",
    "WineOff",
    "Workflow",
    "Worm",
    "Wrench",
    "XLineTop",
    "Zap",
    "ZapOff",
    "ZodiacAquarius",
    "ZodiacAries",
    "ZodiacCancer",
    "ZodiacCapricorn",
    "ZodiacGemini",
    "ZodiacLeo",
    "ZodiacLibra",
    "ZodiacOphiuchus",
    "ZodiacPisces",
    "ZodiacSagittarius",
    "ZodiacScorpio",
    "ZodiacTaurus",
    "ZodiacVirgo",
    "ZoomIn",
    "ZoomOut",
];
//# sourceMappingURL=icon.generated.js.map